import { FormGroup } from './component.styles'

export default FormGroup
